import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  q: () => (/* binding */ IconSustainableRecycledCotton)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/IconSustainableRecycledCotton.tsx


const IconSustainableRecycledCotton = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-sustainable-recycled-cotton-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("circle", { cx: 16, cy: 16, r: 15.5, stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M16 4.79999C9.81446 4.79999 4.80005 9.8144 4.80005 16C4.80005 22.1856 9.81446 27.2 16 27.2C22.1856 27.2 27.2 22.1856 27.2 16C27.2 12.556 25.6456 9.47512 23.2 7.42061", stroke: "#00174F", strokeLinecap: "round" }), (0,jsx_runtime.jsx)("mask", Object.assign({ id: "path-3-inside-1_707_25300", fill: "white" }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7226 13.9109C19.7728 13.6819 19.7993 13.444 19.7993 13.2C19.7993 11.3775 18.322 9.9 16.4998 9.9C14.6775 9.9 13.2002 11.3775 13.2002 13.2C13.2002 13.4442 13.2267 13.6822 13.277 13.9113C11.7327 14.1865 10.5602 15.5363 10.5602 17.16C10.5602 18.9825 12.0375 20.46 13.8598 20.46C14.9401 20.46 15.8992 19.9407 16.5011 19.1381C17.103 19.9407 18.062 20.46 19.1423 20.46C20.9646 20.46 22.4419 18.9825 22.4419 17.16C22.4419 15.5354 21.2682 14.1851 19.7226 13.9109Z" }) })), (0,jsx_runtime.jsx)("path", { d: "M19.7226 13.9109L18.7458 13.6964L18.5226 14.7136L19.5479 14.8955L19.7226 13.9109ZM13.277 13.9113L13.4525 14.8958L14.477 14.7132L14.2538 13.6968L13.277 13.9113ZM16.5011 19.1381L17.3011 18.5382L16.5011 17.4714L15.701 18.5382L16.5011 19.1381ZM18.7993 13.2C18.7993 13.3715 18.7807 13.5375 18.7458 13.6964L20.6993 14.1253C20.7649 13.8263 20.7993 13.5166 20.7993 13.2H18.7993ZM16.4998 10.9C17.7696 10.9 18.7993 11.9296 18.7993 13.2H20.7993C20.7993 10.8253 18.8745 8.9 16.4998 8.9V10.9ZM14.2002 13.2C14.2002 11.9296 15.2299 10.9 16.4998 10.9V8.9C14.125 8.9 12.2002 10.8253 12.2002 13.2H14.2002ZM14.2538 13.6968C14.2188 13.5377 14.2002 13.3716 14.2002 13.2H12.2002C12.2002 13.5168 12.2346 13.8267 12.3003 14.1258L14.2538 13.6968ZM11.5602 17.16C11.5602 16.0293 12.377 15.0875 13.4525 14.8958L13.1016 12.9268C11.0884 13.2856 9.56024 15.0434 9.56024 17.16H11.5602ZM13.8598 19.46C12.5899 19.46 11.5602 18.4304 11.5602 17.16H9.56024C9.56024 19.5347 11.4851 21.46 13.8598 21.46V19.46ZM15.701 18.5382C15.2798 19.0998 14.612 19.46 13.8598 19.46V21.46C15.2682 21.46 16.5185 20.7816 17.3011 19.7381L15.701 18.5382ZM19.1423 19.46C18.3901 19.46 17.7223 19.0998 17.3011 18.5382L15.701 19.7381C16.4836 20.7816 17.7339 21.46 19.1423 21.46V19.46ZM21.4419 17.16C21.4419 18.4304 20.4122 19.46 19.1423 19.46V21.46C21.517 21.46 23.4419 19.5347 23.4419 17.16H21.4419ZM19.5479 14.8955C20.6243 15.0865 21.4419 16.0287 21.4419 17.16H23.4419C23.4419 15.0422 21.912 13.2837 19.8973 12.9262L19.5479 14.8955Z", fill: "#00174F", mask: "url(#path-3-inside-1_707_25300)" }), (0,jsx_runtime.jsx)("path", { d: "M16.5002 15.18V23.1", stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M16.5002 17.82L18.4802 15.84", stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M16.5003 17.82L14.5203 15.84", stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M13.6001 2.40002L16.0001 4.80002L13.6001 7.20002", stroke: "#00174F", strokeLinecap: "round", strokeLinejoin: "round" })] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-sustainable-recycled-cotton-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("circle", { cx: 16, cy: 16, r: 15.5, stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M16 4.79999C9.81446 4.79999 4.80005 9.8144 4.80005 16C4.80005 22.1856 9.81446 27.2 16 27.2C22.1856 27.2 27.2 22.1856 27.2 16C27.2 12.556 25.6456 9.47512 23.2 7.42061", stroke: "#00174F", strokeLinecap: "round" }), (0,jsx_runtime.jsx)("mask", Object.assign({ id: "path-3-inside-1_707_25300", fill: "white" }, { children: (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7226 13.9109C19.7728 13.6819 19.7993 13.444 19.7993 13.2C19.7993 11.3775 18.322 9.9 16.4998 9.9C14.6775 9.9 13.2002 11.3775 13.2002 13.2C13.2002 13.4442 13.2267 13.6822 13.277 13.9113C11.7327 14.1865 10.5602 15.5363 10.5602 17.16C10.5602 18.9825 12.0375 20.46 13.8598 20.46C14.9401 20.46 15.8992 19.9407 16.5011 19.1381C17.103 19.9407 18.062 20.46 19.1423 20.46C20.9646 20.46 22.4419 18.9825 22.4419 17.16C22.4419 15.5354 21.2682 14.1851 19.7226 13.9109Z" }) })), (0,jsx_runtime.jsx)("path", { d: "M19.7226 13.9109L18.7458 13.6964L18.5226 14.7136L19.5479 14.8955L19.7226 13.9109ZM13.277 13.9113L13.4525 14.8958L14.477 14.7132L14.2538 13.6968L13.277 13.9113ZM16.5011 19.1381L17.3011 18.5382L16.5011 17.4714L15.701 18.5382L16.5011 19.1381ZM18.7993 13.2C18.7993 13.3715 18.7807 13.5375 18.7458 13.6964L20.6993 14.1253C20.7649 13.8263 20.7993 13.5166 20.7993 13.2H18.7993ZM16.4998 10.9C17.7696 10.9 18.7993 11.9296 18.7993 13.2H20.7993C20.7993 10.8253 18.8745 8.9 16.4998 8.9V10.9ZM14.2002 13.2C14.2002 11.9296 15.2299 10.9 16.4998 10.9V8.9C14.125 8.9 12.2002 10.8253 12.2002 13.2H14.2002ZM14.2538 13.6968C14.2188 13.5377 14.2002 13.3716 14.2002 13.2H12.2002C12.2002 13.5168 12.2346 13.8267 12.3003 14.1258L14.2538 13.6968ZM11.5602 17.16C11.5602 16.0293 12.377 15.0875 13.4525 14.8958L13.1016 12.9268C11.0884 13.2856 9.56024 15.0434 9.56024 17.16H11.5602ZM13.8598 19.46C12.5899 19.46 11.5602 18.4304 11.5602 17.16H9.56024C9.56024 19.5347 11.4851 21.46 13.8598 21.46V19.46ZM15.701 18.5382C15.2798 19.0998 14.612 19.46 13.8598 19.46V21.46C15.2682 21.46 16.5185 20.7816 17.3011 19.7381L15.701 18.5382ZM19.1423 19.46C18.3901 19.46 17.7223 19.0998 17.3011 18.5382L15.701 19.7381C16.4836 20.7816 17.7339 21.46 19.1423 21.46V19.46ZM21.4419 17.16C21.4419 18.4304 20.4122 19.46 19.1423 19.46V21.46C21.517 21.46 23.4419 19.5347 23.4419 17.16H21.4419ZM19.5479 14.8955C20.6243 15.0865 21.4419 16.0287 21.4419 17.16H23.4419C23.4419 15.0422 21.912 13.2837 19.8973 12.9262L19.5479 14.8955Z", fill: "#00174F", mask: "url(#path-3-inside-1_707_25300)" }), (0,jsx_runtime.jsx)("path", { d: "M16.5002 15.18V23.1", stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M16.5002 17.82L18.4802 15.84", stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M16.5003 17.82L14.5203 15.84", stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M13.6001 2.40002L16.0001 4.80002L13.6001 7.20002", stroke: "#00174F", strokeLinecap: "round", strokeLinejoin: "round" })] })));
};

})();

var __webpack_exports__IconSustainableRecycledCotton = __webpack_exports__.q;
export { __webpack_exports__IconSustainableRecycledCotton as IconSustainableRecycledCotton };
